import cx from 'classnames'
import React from 'react'
import { FieldRenderProps } from 'react-final-form'

import * as styles from './tablet-field.module.css'

const TabletListField: React.FC<FieldRenderProps & { options: Array<{ title: string; subtitle: string }> }> = ({
  input,
  options,
}) => {
  return (
    <div className={styles.list}>
      {options.map((option, index) => (
        <button
          key={index}
          type="button"
          onClick={() => input.onChange({ target: { value: index } })}
          className={cx(styles.button, { [styles.active]: index === input.value })}
        >
          <div className={styles.title}>{option}</div>
        </button>
      ))}
    </div>
  )
}

export default TabletListField
